import React from 'react';
import Typography from '@mui/material/Typography';
import StyledList from 'components/StyledList';
import { styled } from '@mui/system';
import professionCases from 'helpers/professionCases';

const Responsibilities = styled('section')(({ theme }) => ({
  borderRadius: 15,
  border: `2px solid ${theme.palette.primary.main}`,
  backgroundColor: theme.palette.white.main,
  marginBottom: 25
}));

const Title = styled(Typography)(({ theme }) => ({
  padding: '11px 25px 10px',
  fontSize: 24,
  [theme.breakpoints.down('md')]: {
    lineHeight: '34px'
  }
}));

const Content = styled('div')(({ theme }) => ({
  padding: '28px 25px',
  borderTop: `1px solid ${theme.palette.textDisabled.main}`,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  '& ul': {
    width: '100%',
    maxWidth: 640
  },
  '& ul li': {
    marginBottom: 15,
    '&:last-child': {
      marginBottom: 0
    }
  },
  [theme.breakpoints.down('sm')]: {
    padding: '16px 16px'
  }
}));

const ResponsibilitiesComponent = ({ professionInfo, t }) => {
  const workResponsibilities = professionInfo?.workResponsibilities || [];

  // Hide component if workResponsibilities is empty
  if (!workResponsibilities.length) {
    return null;
  }

  return (
    <Responsibilities>
      <Title variant={'h2'}>
        {t('ResponsibilitiesTitle', professionCases(professionInfo, 'nominative'))}
      </Title>
      <Content>
        <StyledList list={workResponsibilities} getText={(item) => item} />
      </Content>
    </Responsibilities>
  );
};

export default ResponsibilitiesComponent;
